import { FC, useMemo } from 'react';
// mui components
import { Grid, Typography } from '@mui/material';
// components
import { RichTextContent } from 'widgets/side-panel/sections/activity-feed/old/components/rich-text-content';
// types
import { IPost } from '_interfaces/post.interface';
import { useGetMeQuery } from 'redux-store/api/auth';
// styles
import { styles } from './styles';

interface IActivityButtonPostItemProps {
  post: IPost;
  handleOpenPostModal: (postId: string) => void;
}

export const ActivityButtonPostItem: FC<IActivityButtonPostItemProps> = ({
  post,
  handleOpenPostModal,
}) => {
  const { data: userMe } = useGetMeQuery();

  const htmlContent = post.message || '';

  const eventType = useMemo(() => {
    const hasMedia = post.media?.length > 0;
    const hasContent = !!post.message;

    if (!hasContent && hasMedia && post.media.every((m) => m.type === 'video')) {
      return 'posted a video';
    }
    if (!hasContent && hasMedia) {
      return 'uploaded a file';
    }
    if (post.mentions?.some((m) => m.profileId === userMe?.id)) {
      return 'mentioned you on post';
    }
    return 'posted to the activity';
  }, [post.message, post.mentions, post.media, userMe?.id]);

  const displayName = post.createdBy?.displayName || '';

  return (
    <Grid sx={styles.postItemContainer}>
      <Grid sx={styles.postItemProfileContainer}>
        <Typography sx={styles.postItemProfile}>
          {`${displayName} `}
          <span onClick={() => handleOpenPostModal(post.id)}>{eventType}</span>
        </Typography>
      </Grid>
      <RichTextContent
        sx={styles.postItemContent}
        content={htmlContent}
        projectId={parseInt(post.projectId) || 0}
      />
    </Grid>
  );
};
